import { useContext } from "react";
import { ThemeProvider } from "@mui/material";
import { ToastContainer } from "react-toastify";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Status from "./status";
import Dashboard from "./dashboard";
import AdminLogin from "./adminlogin";
import Certificate from "./certificate";
import UploadPolicy from "./uploadpolicy";
import { createTheming } from "../utils/Theme";
import AuthLayout from "../layouts/AuthLayout";
import DashboardLayout from "../layouts/DashboardLayout";
import SettingsContext from "../context/SettingsContext";

function App() {
  const themeSeeting = useContext(SettingsContext);
  const theme = createTheming({
    theme: themeSeeting.settings.theme,
  });

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          {/* Normal Page (Default) */}
          <Route path="/" element={<UploadPolicy />} />
          <Route path="/download-certificate" element={<Certificate />} />
          <Route path="/status" element={<Status />} />

          {/* Auth Layout */}
          {/* <Route element={<AuthLayout />}>
            <Route path="/admin-signin" element={<AdminLogin />} />
          </Route> */}
          <Route
            path="/admin-signin"
            element={
              <AuthLayout>
                <AdminLogin />
              </AuthLayout>
            }
          />

          {/* Dashboard Layout */}
          {/* <Route element={<DashboardLayout />}>
            <Route path="/admin-dashboard" element={<Dashboard />} />
          </Route> */}
          <Route
            path="/admin-dashboard"
            element={
              <DashboardLayout>
                <Dashboard />
              </DashboardLayout>
            }
          />
        </Routes>
        <ToastContainer position="top-right" />
      </Router>
    </ThemeProvider>
  );
}

export default App;
